import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-four',
  templateUrl: './header-four.component.html',
  styleUrls: ['./header-four.component.scss']
})
export class HeaderFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
